import { render, staticRenderFns } from "./MultiplesSuscriptores.vue?vue&type=template&id=6b0bb482&scoped=true"
import script from "./MultiplesSuscriptores.vue?vue&type=script&lang=js"
export * from "./MultiplesSuscriptores.vue?vue&type=script&lang=js"
import style0 from "./MultiplesSuscriptores.vue?vue&type=style&index=0&id=6b0bb482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bb482",
  null
  
)

export default component.exports